import { render } from "./ListOfMovement.vue?vue&type=template&id=6f3651e2&scoped=true"
import script from "./ListOfMovement.vue?vue&type=script&lang=js"
export * from "./ListOfMovement.vue?vue&type=script&lang=js"

import "./ListOfMovement.vue?vue&type=style&index=0&id=6f3651e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3651e2"]])

export default __exports__